"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    /** Observable ID allocator */
    // tslint:disable-next-line:variable-name
    $dyn._observableId = 1;
    function isObservable(object) {
        return object && object.valueChanged ? true : false;
    }
    $dyn.isObservable = isObservable;
    /**
     * Unwraps if the given object is observable, or otherwise returns the object as value.
     * @param object The object to unwrap.
     * @returns The current unwrapped value.
     */
    function value(object) {
        if (object && object.valueChanged) {
            return object();
        }
        else {
            return object;
        }
    }
    $dyn.value = value;
    /**
     * Accesses the value of an observable variable, without creating a dependency.
     * @param object  The observable whose value to access.
     * @returns The current value in the observable property
     */
    function peek(object) {
        if (object && object.valueChanged) {
            return object.valueChanged.peek();
        }
        else {
            return object;
        }
    }
    $dyn.peek = peek;
    /**
     * Disposes of an object or observable.
     * @param object The object/observable to dispose.
     */
    function dispose(object) {
        if (object) {
            if (object.valueChanged && object.valueChanged.dispose) {
                object.valueChanged.dispose();
            }
            else if (object.dispose) {
                object.dispose();
            }
        }
    }
    $dyn.dispose = dispose;
    /**
     * Sets a value of a object property.  Works with both observable and non-observable values.
     */
    // tslint:disable-next-line:no-shadowed-variable
    function setValue(obj, prop, value, forceChange) {
        if (obj) {
            // tslint:disable-next-line:no-shadowed-variable
            var observable_1 = obj[prop];
            if ($dyn.isObservable(observable_1)) {
                observable_1(value, forceChange);
            }
            else {
                obj[prop] = value;
            }
        }
    }
    $dyn.setValue = setValue;
    /**
     * Sets a value of a object property.  Ensure value becomes observable if it wasn't already.
     */
    // tslint:disable-next-line:no-shadowed-variable
    function setObservableValue(obj, prop, value, forceChange) {
        // tslint:disable-next-line:no-shadowed-variable
        var observable = obj[prop];
        if ($dyn.isObservable(observable)) {
            observable(value, forceChange);
        }
        else {
            observable = obj[prop] = $dyn.observable(value);
            if ($dyn.debug.general) {
                obj[prop].__prop = prop;
            }
        }
        return observable;
    }
    $dyn.setObservableValue = setObservableValue;
    /**
     * Subscribes a function to changes of an observable.
     * @description Utility method that binds an observer logic to an observing logic.
     * Observing logic is evaluated in an observable wrapper and the resulting value is passed
     * as the first argument to the observer logic. Observer is executed first time and then
     * any time subsequently when the observing value changes.  If the observer returns false,
     * the observation is stopped and the subscription is disposed.
     * @example
     *  // The following example shows how a function can automatically subscribe to observables simply by accessing the observable using $dyn.value.
     *  // Every time one of the observables  (FirstName or LastName) changes its value, then the first function has also changed its value.
     *  // When this happens, the second function (the callback function) will log the concatenation of the observable values to the console.
     *  self.FirstName = $dyn.observable("Joanne");
     *  self.LastName = $dyn.observable("Gordon");
     *  $dyn.observe(
     *      function () {
     *          // Joann + " " + Gordon
     *          return $dyn.value(self.FirstName) + " " + $dyn.value(self.LastName);
     *      },
     *      function (value) {
     *          // "Joanne Gordon"
     *          console.log(value);
     *      }
     *  );
     *
     * @example
     *  // The following example performs similarly to the previous example. However, this example uses a computed observable, named myComp, to handle the concatenation.
     *  self.FirstName = $dyn.observable("Joanne");
     *  self.LastName = $dyn.observable("Gordon");
     *  self.myComp = $dyn.computed(function () {
     *      // Joanne + " " + Gordon
     *      return $dyn.value(self.FirstName) + " " + $dyn.value(self.LastName);
     *  });
     *  $dyn.observe(
     *      self.myComp,
     *      function (value) {
     *          // "Joanne Gordon"
     *          console.log(value);
     *      }
     *  );
     *
     * @param observing The observable to be observed.
     * @param observer The function to invoke upon registration and also later when the observable is updated. Function is invoked with one argument,
     *                   the value of the observable. If Observer returns false, then we un-subscribed automatically.
     * @param thisArg Context to pass to the Observer. The Context becomes the this variable inside of the observer.
     * @param disposableObserver Unsubscribes the supplied DisposableObserver. Any observer which it is currently observing and needs to be disposed before creating a new observer.
     * @param skipFirstTimeFire Do not fire when this function is first called.
     * @returns The subscription.
     */
    function observe(observing, observer, thisArg, disposableObserver, skipFirstTimeFire) {
        if (disposableObserver) {
            $dyn.dispose(disposableObserver);
        }
        // tslint:disable-next-line:no-shadowed-variable
        var observable = null;
        var createdComputed = false;
        if (isObservable(observing)) {
            observable = observing;
        }
        else if (typeof observing === "function") {
            observable = $dyn.computed(observing);
            createdComputed = true;
        }
        else {
            // Value isn't observable, so apply first-time init then return
            // immediately.
            observer.apply(thisArg, [observing]);
            return $dyn.observe._objectDispose;
        }
        // Subscribe to the valueChanged on our observable object
        // tslint:disable-next-line:no-shadowed-variable
        var subscriptionId = observable.valueChanged.subscribe(function (value) {
            if (observer.apply(thisArg, [$dyn.value(value)]) === false) {
                // No need to observe any more, remove the subscription
                observable.valueChanged.unsubscribe(subscriptionId);
            }
        });
        // First time init -- must always get value to create dependency where desired
        // tslint:disable-next-line:no-shadowed-variable
        var value = $dyn.value(observable);
        if (!observable.__skipFirstTimeFire && !skipFirstTimeFire) {
            if (observer.apply(thisArg, [value]) === false) {
                // No need to observe any more, remove the subscription
                observable.valueChanged.unsubscribe(subscriptionId);
            }
        }
        return {
            _observable: observable,
            _subscriptionId: subscriptionId,
            dispose: function () {
                if (observable && observable.valueChanged) {
                    observable.valueChanged.unsubscribe(subscriptionId);
                    if (createdComputed && observable.valueChanged.clearAllDependencies) {
                        observable.valueChanged.clearAllDependencies();
                        observable = null;
                    }
                    this._subscriptionId = null;
                    this._observable = null;
                }
            },
        };
    }
    $dyn.observe = observe;
    (function (observe) {
        // tslint:disable-next-line:variable-name
        observe._objectDispose = {
            _observable: undefined,
            _subscriptionId: undefined,
            dispose: function () { },
        };
    })(observe = $dyn.observe || ($dyn.observe = {}));
    /**
     * Utility method that binds observer to changes in observing object properties.
     * @description Utility method that binds observer to changes in observing object properties.
     * Notification happens when updatingFlag becomes false.
     * Observer receives changes map that contains names of the properties that were changed.
     * The observing object properties should be observables to meet the purpose of the usage of this utility
     * @example  $dyn.bulkObserve({prop1: observable1, prop2: observable2}, function(changes){//observing logic}, thisCallerContext, currentObserver);
     *
     * @param observing The object, observable properties of which to be observed.
     * @param observer The function to be called when the observable has changed and updatingFlag is set to false. Receives changes map
     * @param updatingFlag The updatingFlag (supposed to be observable) that indicates when to notify observer about changes
     * @param thisArg The "this" to apply when the observer callback is fired. Provide this parameter if the callback requires "this" context.
     * @param disposableObserver Unsubscribes the supplied DisposableObserver. Any observer which it is currently observing and needs to be disposed before creating a new observer.
     * @param propsToObserve Map of properties to observe. If undefined then observe all observable properties.
     * @param skipFirstTimeFire Do not fire when this function is first called.
     * @returns The subscription.
     */
    function bulkObserve(observing, observer, updatingFlag, thisArg, disposableObserver, propsToObserve, skipFirstTimeFire) {
        if (disposableObserver) {
            $dyn.dispose(disposableObserver);
        }
        var changes = {};
        var disposables = [];
        function addChange(propertyName) {
            if (!changes[propertyName]) {
                changes[propertyName] = 1;
            }
            else {
                changes[propertyName]++;
            }
        }
        var subscriptionId;
        if ($dyn.isObservable(updatingFlag)) {
            // Subscribe to the valueChanged on updatingFlag
            // tslint:disable-next-line:no-shadowed-variable
            subscriptionId = updatingFlag.valueChanged.subscribe(function (value) {
                if ($dyn.value(value) === false && changes && Object.keys(changes).length) {
                    // Prevent short circuit calls
                    var currentChanges = {};
                    $.extend(true, currentChanges, changes);
                    changes = {};
                    observer.call(thisArg, currentChanges);
                }
            });
        }
        else {
            updatingFlag = false;
        }
        for (var propName in observing) {
            if (!propsToObserve || propsToObserve[propName]) {
                (function observeBulkProp(currentPropName) {
                    var propValue = observing[currentPropName];
                    if ($dyn.isObservable(propValue) && propValue !== updatingFlag) {
                        disposables.push($dyn.observe(propValue, function () {
                            if (!$dyn.value(updatingFlag)) {
                                addChange(currentPropName);
                                var currentChanges = {};
                                $.extend(true, currentChanges, changes);
                                changes = {};
                                observer.call(thisArg, currentChanges);
                            }
                            else {
                                addChange(currentPropName);
                            }
                        }, thisArg, undefined, skipFirstTimeFire));
                    }
                })(propName);
            }
        }
        return {
            _observable: updatingFlag,
            _subscriptionId: subscriptionId,
            dispose: function () {
                if (updatingFlag && updatingFlag.valueChanged && subscriptionId !== undefined && subscriptionId !== null) {
                    updatingFlag.valueChanged.unsubscribe(subscriptionId);
                }
                if (disposables) {
                    for (var i = 0, len = disposables.length; i < len; ++i) {
                        disposables[i].dispose && disposables[i].dispose();
                    }
                    disposables = null;
                }
                changes = null;
            },
        };
    }
    $dyn.bulkObserve = bulkObserve;
    function oneWayBinding(source, target) {
        if (!$dyn.isObservable(source)) {
            throw new Error("The parameter 'source' is not observable in binding");
        }
        if (!$dyn.isObservable(target)) {
            throw new Error("The parameter 'target' is not observable in binding");
        }
        $dyn.disposeOneWayBinding(target);
        // Set the initial value.
        target.__bindingUpdating = true;
        target.valueChanged.setValue(source());
        target.__bindingUpdating = false;
        target.__oneWayBindingSource = source;
        target.__oneWayBindingId = source.valueChanged.subscribe(function oneWayBinding_sourceChanged() {
            target.__bindingUpdating = true;
            target.valueChanged.setValue(source());
            target.__bindingUpdating = false;
        });
    }
    $dyn.oneWayBinding = oneWayBinding;
    function disposeOneWayBinding(target) {
        if (target && target.__oneWayBindingId !== undefined) {
            var source = target.__oneWayBindingSource;
            source.valueChanged.unsubscribe(target.__oneWayBindingId);
            if ($dyn.debug.general) {
                if (!target.__prevOneWayBindings) {
                    target.__prevOneWayBindings = [];
                }
                target.__prevOneWayBindings.push({
                    oneWayBindingId: target.__oneWayBindingId,
                    oneWayBindingSource: target.__oneWayBindingSource,
                });
            }
            delete target.__oneWayBindingId;
            delete target.__oneWayBindingSource;
        }
    }
    $dyn.disposeOneWayBinding = disposeOneWayBinding;
    /**
     * Make an observable plain object into a deeply observable object (observable at all levels).
     * @param observable The observable plain object.
     * @param notifyOnAllChanges Notify the root observable object when any descendant changes
     */
    // tslint:disable-next-line:no-shadowed-variable
    function observableObject(observable, notifyOnAllChanges) {
        if (notifyOnAllChanges === void 0) { notifyOnAllChanges = false; }
        observable.__observableObject = undefined;
        // tslint:disable-next-line:no-shadowed-variable
        $dyn.observe(observable, function (value) {
            if (!observable.__syncingObservableObject) {
                var observer = notifyOnAllChanges ? observable : undefined;
                observable.__syncingObservableObject = true;
                observable.__observableObject = $dyn.syncObservableObject(observable.__observableObject, value, undefined, undefined, observer);
                observable.__syncingObservableObject = false;
            }
        });
        return observable.__observableObject;
    }
    $dyn.observableObject = observableObject;
    /**
     * Really should be called deep sync
     * @param observableTarget
     * @param source
     * @param property
     * @param wrap Make the target an observable object if it is not already
     * @param rootObservable If a rootObservable is passed in, it will be notified of changes
     */
    function syncObservableObject(observableTarget, source, property, wrap, rootObservable) {
        if (wrap === void 0) { wrap = true; }
        // TODO: review usage and semantics to determine if this is needed and useful.
        if (!source) {
            return;
        }
        var targetValue;
        var sourceValue;
        if (property === undefined) {
            sourceValue = source;
        }
        else {
            sourceValue = source[property];
        }
        if ($.isPlainObject(sourceValue)) {
            // TODO: Plain objects will be made observable, but changes to them will not notify the rootObservable.
            if (wrap) {
                if (!observableTarget) {
                    targetValue = {};
                    observableTarget = $dyn.observable(targetValue);
                }
                else {
                    targetValue = $dyn.value(observableTarget);
                }
                observableTarget.__source = sourceValue;
            }
            else {
                observableTarget = targetValue = {};
            }
            for (var childProperty in sourceValue) {
                if (childProperty && childProperty[0] !== " ") {
                    targetValue[childProperty] = $dyn.syncObservableObject(targetValue[childProperty], sourceValue, childProperty, undefined, rootObservable);
                }
            }
        }
        else if ($.isArray(sourceValue)) {
            if (!observableTarget) {
                // Backing object for the array, different instance than the source value.
                observableTarget = $dyn.observable([]);
            }
            targetValue = observableTarget();
            observableTarget.__source = sourceValue;
            targetValue.length = sourceValue.length; // Trim array to be the correct size.
            for (var index = 0, len = sourceValue.length; index < len; index++) {
                targetValue[index] = $dyn.syncObservableObject(targetValue[index], sourceValue, index.toString(), false, rootObservable);
            }
            // TODO: Implement other array methods as needed
            // tslint:disable-next-line:no-shadowed-variable
            observableTarget.push = function (value) {
                var endIndex = targetValue.length;
                sourceValue[endIndex] = value;
                var returnValue = targetValue.push($dyn.syncObservableObject(targetValue[endIndex], sourceValue, endIndex, false, rootObservable));
                observableTarget.valueChanged.raise();
                if (rootObservable) {
                    rootObservable.__syncingObservableObject = true;
                    rootObservable.valueChanged.raise();
                    rootObservable.__syncingObservableObject = false;
                }
                return returnValue;
            };
            // tslint:disable-next-line:only-arrow-functions
            observableTarget.splice = function (start, deleteCount) {
                var varArgs = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    varArgs[_i - 2] = arguments[_i];
                }
                // Can take variable arguments
                var returnValue = sourceValue.splice.apply(sourceValue, arguments); // return the items that were deleted
                targetValue.length = sourceValue.length; // trim the targetArray length to match its source.
                for (var i = start; i < targetValue.length; i++) {
                    // sync all items affected by the splice
                    targetValue[i] = $dyn.syncObservableObject(null, sourceValue, i, false, rootObservable);
                }
                observableTarget.valueChanged.raise();
                if (rootObservable) {
                    rootObservable.__syncingObservableObject = true;
                    rootObservable.valueChanged.raise();
                    rootObservable.__syncingObservableObject = false;
                }
                return returnValue;
            };
            observableTarget.valueChanged.raise();
        }
        else {
            if (property === undefined) {
                if (!observableTarget) {
                    observableTarget = $dyn.observable(source);
                }
            }
            else if (!observableTarget) {
                observableTarget = $dyn.mappedObservable(source, property, rootObservable);
            }
            observableTarget.__source = source;
        }
        return observableTarget;
    }
    $dyn.syncObservableObject = syncObservableObject;
    function mappedObservable(currentObject, property, rootObservable) {
        // tslint:disable-next-line:no-shadowed-variable
        var observable = $dyn.observable();
        observable.__source = currentObject;
        observable.__property = property;
        Object.defineProperty(observable, "_current", {
            get: function () {
                return observable.__source[property];
            },
            // tslint:disable-next-line:no-shadowed-variable
            set: function (value) {
                observable.__source[property] = value;
                if (rootObservable) {
                    rootObservable.__syncingObservableObject = true;
                    // First parameter is undefined, because it is not used in the 'raise'
                    // If internal property of the value changed, whole value will not be changed.
                    // And subscribers will not be able to determine whether value changed or not.
                    // forceChange == true, to notify subscribers that state of the object changed.
                    rootObservable.valueChanged.raise(undefined, true);
                    rootObservable.__syncingObservableObject = false;
                }
            },
        });
        return observable;
    }
    $dyn.mappedObservable = mappedObservable;
    // tslint:disable-next-line:no-shadowed-variable
    function observable(value) {
        return (new $dyn.observable._ObservableHost(value))._observable;
    }
    $dyn.observable = observable;
    (function (observable) {
        // tslint:disable-next-line:class-name
        var _ObservableHost = /** @class */ (function (_super) {
            __extends(_ObservableHost, _super);
            // tslint:disable-next-line:no-shadowed-variable
            function _ObservableHost(value) {
                var _this = _super.call(this) || this;
                _this._observable = Object.assign(function (newValue, forceChange) {
                    if (newValue !== undefined) {
                        return _this.setValue(newValue, forceChange);
                    }
                    else {
                        return _this.getValue();
                    }
                }, {
                    _current: value,
                    toString: function () {
                        return _this.toString();
                    },
                    valueChanged: _this,
                });
                return _this;
            }
            /**
             * Peeks into the current value without creating dependency
             */
            _ObservableHost.prototype.peek = function () {
                return this._observable._current;
            };
            /**
             * Raises the value changed event for the observable.
             * @param forceChange Indicates whether to force raise change even if the new value is equal to the old value.
             */
            _ObservableHost.prototype.raise = function (_observable, forceChange) {
                if (forceChange === void 0) { forceChange = false; }
                _super.prototype.raise.call(this, this._observable, forceChange);
            };
            /**
             * The getter for the observable host
             */
            _ObservableHost.prototype.getValue = function () {
                var scope = $dyn.computed.scope;
                // Wire-up dependency with the scope, lastSeenScope is a perf optimization
                if (scope && this.lastSeenScope !== scope) {
                    scope.valueChanged.addDependency(this._observable);
                    this.lastSeenScope = scope;
                }
                return this._observable._current;
            };
            /**
             * The setter for the observable host
             * @param newValue The new value
             * @param forceChange Force the value to update, even if it appears the same as the previous value.
             */
            _ObservableHost.prototype.setValue = function (newValue, forceChange) {
                if (forceChange === void 0) { forceChange = false; }
                if (newValue === this._observable) {
                    throw new Error("Cycle detected in observable");
                }
                // this is writing value
                var oldValue = this._observable._current;
                if (oldValue !== newValue) {
                    this._observable._current = newValue;
                    this.raise(this._observable);
                }
                else if (forceChange) {
                    // Raises the value changed event when forceChange is set to true.
                    this.raise(this._observable, forceChange);
                }
                return this._observable._current;
            };
            _ObservableHost.prototype.toString = function () {
                return this._observable._current + " [Observable]";
            };
            return _ObservableHost;
        }($dyn.eventHost));
        observable._ObservableHost = _ObservableHost;
    })(observable = $dyn.observable || ($dyn.observable = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Observable.js.map
